import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  useGetDataBlocksQuery,
  useGetDataTemplatesQuery,
} from "@/redux/service";
import BaseTabs from "@/components_v2/Tabs/BaseTabs";
import BaseSpinner from "@/components_v2/Spiner/BaseSpinner";
import {
  DataBlockListResponse,
  DataTemplateResponse,
} from "@/redux/datablocks/types";
import { EvidenceExample } from "@/features/datablocks/documentation/components/EvidenceExample";

import "./styles.css";

const EvidenceDocumentation = () => {
  const { t } = useTranslation();
  const { data: dataTemplates } = useGetDataTemplatesQuery({
    pagination: "off",
    disabled: false,
    isEvidence: true,
  }) as { data: DataTemplateResponse[] };
  const { data: exampleDataBlocks } = useGetDataBlocksQuery({
    pagination: "off",
    isExample: true,
  }) as { data: DataBlockListResponse[] };

  const dataTemplatesWithExamples = useMemo(() => {
    if (!dataTemplates || !exampleDataBlocks) return;

    return dataTemplates.map((template) => ({
      ...template,
      examples: exampleDataBlocks.filter(
        (block) => block.template.id === template.id,
      ),
    }));
  }, [dataTemplates, exampleDataBlocks]);

  const tabs = useMemo(() => {
    if (!dataTemplatesWithExamples) return [];

    return dataTemplatesWithExamples.map((template) => ({
      label: template.title,
      icon: <img src={template.icon} alt={template.title} />,
      key: template.title.toLowerCase(),
      children: <EvidenceExample template={template} />,
    }));
  }, [dataTemplatesWithExamples]);

  if (!dataTemplatesWithExamples) {
    return (
      <div className="data-block-loading-state">
        <BaseSpinner />
      </div>
    );
  }

  return (
    <div className="data-blocks-documentation">
      <div>
        <h1 className="header-l-medium">
          {t("datablocks.labels.documentationTitle")}
        </h1>
        <p className="data-blocks-documentation-help-text body-m-regular">
          {t("datablocks.labels.documentationHelpText")}
        </p>
      </div>

      <BaseTabs items={tabs} tabPosition="left" />
    </div>
  );
};

export default EvidenceDocumentation;
